
import React, { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('subject', formData.subject);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d6ae2uvmvg9ih2c7ahjg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <section id="contact" className="py-12 sm:py-20 bg-[#F5F3EF]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12">
          <div>
            <h2 className="text-2xl sm:text-4xl font-bold mb-4 sm:mb-6 text-gray-800">
              お問い合わせ
            </h2>
            <p className="text-xs sm:text-sm text-gray-600 mb-6 sm:mb-8 leading-relaxed">
              ご質問やご意見、ご要望などお気軽にお問い合わせください。皆様からのご連絡をお待ちしております。
            </p>
            <div className="space-y-3 sm:space-y-4">
              <div>
                <p className="text-xs sm:text-sm font-semibold text-gray-800 mb-1">
                  住所
                </p>
                <p className="text-xs sm:text-sm text-gray-600">
                  〒558-0002 大阪府大阪市住吉区長居西1-12-36
                </p>
              </div>
              <div>
                <p className="text-xs sm:text-sm font-semibold text-gray-800 mb-1">
                  メール
                </p>
                <a
                  href="mailto:union.hiro528@gmail.com"
                  className="text-xs sm:text-sm text-gray-600 hover:text-gray-800 cursor-pointer break-all"
                >
                  union.hiro528@gmail.com
                </a>
              </div>
              <div>
                <p className="text-xs sm:text-sm font-semibold text-gray-800 mb-1">
                  電話
                </p>
                <a
                  href="tel:090-2438-6991"
                  className="text-xs sm:text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                >
                  090-2438-6991
                </a>
              </div>
            </div>
          </div>

          <div>
            <form
              id="contact_form"
              data-readdy-form
              onSubmit={handleSubmit}
              className="space-y-4 sm:space-y-6"
            >
              <div>
                <label
                  htmlFor="name"
                  className="block text-xs sm:text-sm font-medium text-gray-800 mb-1 sm:mb-2"
                >
                  名前 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-800 text-sm"
                  placeholder="名前を入力してください"
                />
              </div>

              <div>
                <label
                  htmlFor="email"
                  className="block text-xs sm:text-sm font-medium text-gray-800 mb-1 sm:mb-2"
                >
                  メールアドレス <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-800 text-sm"
                  placeholder="メールアドレスを入力"
                />
              </div>

              <div>
                <label
                  htmlFor="subject"
                  className="block text-xs sm:text-sm font-medium text-gray-800 mb-1 sm:mb-2"
                >
                  件名
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-800 text-sm"
                  placeholder="件名を入力してください"
                />
              </div>

              <div>
                <label
                  htmlFor="message"
                  className="block text-xs sm:text-sm font-medium text-gray-800 mb-1 sm:mb-2"
                >
                  メッセージ
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows={5}
                  maxLength={500}
                  className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-800 text-sm resize-none"
                  placeholder="メッセージを入力..."
                />
                <p className="text-xs text-gray-500 mt-1">
                  {formData.message.length}/500文字
                </p>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full px-6 py-3 bg-black text-white text-sm font-semibold rounded-full hover:bg-gray-800 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
              >
                {isSubmitting ? '送信中...' : '送信'}
              </button>

              {submitStatus === 'success' && (
                <p className="text-sm text-green-600 text-center">
                  送信が完了しました。
                </p>
              )}
              {submitStatus === 'error' && (
                <p className="text-sm text-red-600 text-center">
                  送信に失敗しました。もう一度お試しください。
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
